// in src/users.js
import React from 'react';
import { InputUploadInput, EmailField, BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const conditionDelete = WrappedComponent => props => {
    return (
        props.record && props.record.typeId === 1 &&
        <WrappedComponent {...props} />
    )
};


const ConditionalDeleteButton = conditionDelete(DeleteButton);

export const MyUserList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Usuarios">
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.username}
                    secondaryText={record => record.email}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="username" label="Nombre de Usuario" />
                    <EmailField source="email" label="Email" />
                    <ReferenceField label="Rol" source="typeId" reference="user-types">
                        <TextField source="name" />
                    </ReferenceField>
                    <ConditionalDeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

export const MyUserCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="firstName" label="Nombre(s)" validate={[Validators.required]} />
            <TextInput source="lastName" label="Apellidos" validate={[Validators.required]} />
            <TextInput source="email" type="email" label="Email" validate={[Validators.required]} />
            <TextInput source="username" label="Nombre de Usuario" validate={[Validators.required]} />
            <ReferenceInput label="Rol" source="typeId" reference="user-types" allowEmpty>
                <SelectInput optionText="name" source="typeId" validate={required} />
            </ReferenceInput>
            <TextInput source="password" type="password" label="Contraseña" validate={[Validators.required]} />
        </SimpleForm>
    </Create>
);
